/**
 * @file ComponentsStateView.jsx
 * @author Daniel Aguirre
 * @description Component State View Page
 */

// Dependencies
import PropTypes from 'prop-types';
import { Divider, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import AppCardLayout from '@nephro/components/AppCardLayout';
import React from 'react';
import useServiceState from './useServiceState';
import HeaderServiceState from './headerServiceState';
import {
  NEPHRO_MASTER,
  NEPHRO_AUTH,
  NEPHRO_INTEGRATOR,
  NEPHRO_CALENDAR,
  NEPHRO_MEDIA,
  ONLINE
} from './constants';

function ComponentsStateView({ componentsStateActions }) {
  const { t: translate } = useTranslation();

  const {
    getNephroMasterState,
    getNephroAuthState,
    getNephroIntegratorState,
    getNephroCalendarState,
    getNephroMediaState
  } = componentsStateActions;

  const nephroMasterState = useServiceState({
    name: NEPHRO_MASTER,
    getState: getNephroMasterState
  });

  const nephroAuthState = useServiceState({
    name: NEPHRO_AUTH,
    getState: getNephroAuthState
  });

  const nephroIntegratorState = useServiceState({
    name: NEPHRO_INTEGRATOR,
    getState: getNephroIntegratorState
  });

  const nephroCalendarState = useServiceState({
    name: NEPHRO_CALENDAR,
    getState: getNephroCalendarState
  });

  const nephroMediaState = useServiceState({
    name: NEPHRO_MEDIA,
    getState: getNephroMediaState
  });

  const componentsData = [
    nephroAuthState,
    nephroMasterState,
    nephroIntegratorState,
    nephroCalendarState,
    nephroMediaState
  ];

  return (
    <AppCardLayout>
      <div className="h-full flex flex-col">
        <HeaderServiceState componentsData={componentsData} />
        <Divider className="bg-gray-200" style={{ margin: 0 }} />
        {componentsData.map((item, index) => {
          return (
            <div
              key={index}
              className="p-3 flex flex-row justify-between items-center">
              <h2 className="text-sm text-secondary w-6/12">
                {translate(item.name)}
              </h2>
              <div className="w-6/12">
                <Tag color={item.state === ONLINE ? 'green' : 'volcano'}>
                  {item.state === ONLINE
                    ? translate('components.stateOn')
                    : translate('components.stateOff')}
                </Tag>
              </div>
            </div>
          );
        })}
      </div>
    </AppCardLayout>
  );
}

/**
 * Component definition of proptypes.
 */
ComponentsStateView.propTypes = {
  componentsStateActions: PropTypes.shape({
    getNephroMasterState: PropTypes.func.isRequired,
    getNephroAuthState: PropTypes.func.isRequired,
    getNephroIntegratorState: PropTypes.func.isRequired,
    getNephroCalendarState: PropTypes.func.isRequired,
    getNephroMediaState: PropTypes.func.isRequired
  }).isRequired
};

export default ComponentsStateView;
